import React from 'react';
import { Code, Monitor, Layers, Zap, ArrowRight, Mail, Github, Linkedin, Twitter } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import WebDesignAboutMe from '../WebAbout/WebDesignAboutMe';
import styles from './WebDesignHero.module.css';

const WebDesignHero = ({ mousePosition }) => {
  const navigate = useNavigate();

  const handleViewProjects = () => {
    navigate('/all-projects');
  };

  const handleGetInTouch = () => {
    navigate('/contact');
  };
  return (
    <>
      {/* Hero Section */}
      <section className={styles.hero}>
        {/* Animated Background Elements */}
        <div className={styles.bgElements}>
          <div className={styles.blobWeb1} style={{ transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)` }}></div>
          <div className={styles.blobWeb2} style={{ transform: `translate(${-mousePosition.x}px, ${-mousePosition.y}px)` }}></div>
          <div className={styles.blobWeb3}></div>
        </div>

        {/* Mesh Gradient Overlay */}
        <div className={styles.meshGradientWeb}></div>

        {/* Floating Shapes */}
        <div className={styles.floatingShapes}>
          {[...Array(6)].map((_, i) => (
            <div key={i} className={`${styles.shape} ${styles[`shapeWeb${i + 1}`]}`}></div>
          ))}
        </div>

        <div className={styles.heroContent}>
          <div className={styles.heroGrid}>
            {/* Left Side - Text Content */}
            <div className={styles.heroText}>
              <div className={styles.badgeWeb}>
                <Code size={18} className={styles.badgeIcon} />
                <span>Full-Stack Developer</span>
              </div>

              <h1 className={styles.heroTitle}>
                <span className={styles.titleLine1Web}>Building Digital</span>
                <span className={styles.titleLine2Web}>Experiences That</span>
                <span className={styles.titleLine3Web}>Inspire & Engage</span>
              </h1>

              <p className={styles.heroSubtitle}>
                Crafting modern, responsive websites and web applications with
                cutting-edge technologies and innovative design solutions.
              </p>

              <div className={styles.heroCta}>
                <button className={styles.primaryBtnWeb} onClick={handleViewProjects}>
                  <span className={styles.btnText}>View Projects</span>
                  <ArrowRight size={20} />
                </button>
                <button className={styles.secondaryBtn} onClick={handleGetInTouch}>
                  <Mail size={18} />
                  <span>Get In Touch</span>
                </button>
              </div>

              {/* Social Links */}
              <div className={styles.socialLinks}>
                <a href="https://github.com/pavithra-chandran" target="_blank" rel="noreferrer" className={styles.socialLink}><Github size={20} /></a>
                <a href="https://www.linkedin.com/in/pavithra-chandran/" target="_blank" rel="noreferrer" className={styles.socialLink}><Linkedin size={20} /></a>
              </div>
            </div>

            {/* Right Side - Visual Showcase */}
            <div className={styles.heroVisual}>
              <div className={styles.webShowcase}>
                {/* Browser Window Mockup */}
                <div className={styles.browserWindow}>
                  <div className={styles.browserHeader}>
                    <div className={styles.browserDots}>
                      <div className={styles.dot1}></div>
                      <div className={styles.dot2}></div>
                      <div className={styles.dot3}></div>
                    </div>
                    <div className={styles.browserUrl}>pavithrachandran.com</div>
                  </div>
                  <div className={styles.browserContent}>
                    <div className={styles.codeLines}>
                      <div className={styles.codeLine1}></div>
                      <div className={styles.codeLine2}></div>
                      <div className={styles.codeLine3}></div>
                      <div className={styles.codeLine4}></div>
                    </div>
                    <Monitor size={64} className={styles.monitorIcon} />
                  </div>
                </div>

                {/* Decorative Frame */}
                <div className={styles.webFrame}></div>
                <div className={styles.webGlow}></div>
              </div>

              {/* Floating Stats */}
              <div className={styles.statCard1Web}>
                <Layers size={20} className={styles.iconWeb} />
                <div className={styles.statNumber}>50+</div>
                <div className={styles.statLabel}>Projects</div>
              </div>
              <div className={styles.statCard2Web}>
                <Zap size={20} className={styles.iconWeb} />
                <div className={styles.statNumber}>Fast</div>
                <div className={styles.statLabel}>Performance</div>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className={styles.scrollIndicator}>
          <div className={styles.scrollWheel}>
            <div className={styles.scrollDotWeb}></div>
          </div>
          <span className={styles.scrollText}>Scroll to explore</span>
        </div>
      </section>

      <WebDesignAboutMe />
    </>
  );
};


export default WebDesignHero;